export * from './IconSkype';
